class Sorter {
  sortByProperty(array, property) {
    return array.sort((a, b) => {
      const aValue = a[property].toLowerCase();
      const bValue = b[property].toLowerCase();
      return aValue.localeCompare(bValue);
    });
  }
}
const sorter = new Sorter();
export default sorter;